import api from "../../api/api";

export const getAllFlnmaster = async (data) =>
  await api.get(
    `getflnmasterdata/${data.assesment}/${data.language}/${data.program}/${data.clas}/${data.subject}`
  );

export const createAllFlnmaster = async (data) =>
  await api.post(`saveflnmasterdata`, data);

export const updateFlnMaster = async (data) =>
  await api.put(`updateflnmasterdata/${data._id}`, data.update_fln);

export const deleteFlnMaster = async (_id) =>
  await api.put(`deletemasterflncontent/${_id}`);

export const uploadFlnDocument = async (data) =>
  await api.post(`saveflnactivitydocument`, data);
export const getFlnDocument = async (data) =>
  await api.get(`getflnactivitydocument/${data.program}/${data.clas}`);
export const deleteFlnDocument = async (_id) =>
  await api.put(`delete_fln_activity/${_id}`);
